import {view} from '@sail/ui';
import {ScreenWrapper} from 'src/components/core/ScreenWrapper';
import {UserFacingError} from 'src/utils/error';
import messages from 'src/utils/messages';
import {Text} from 'src/v2/components/common/Text';
import {useLogger} from 'src/utils/logger';
import {useIntl} from '@sail/intl';

const AppError = ({error}: {error: Error}) => {
  const intl = useIntl();
  const logger = useLogger();
  logger.log('crypto_payin_session.error', {
    error_type: 'APP_ERROR',
    error_message: error.message,
  });
  return (
    <ScreenWrapper alwaysCentered>
      <view.div
        css={{
          stack: 'y',
          gap: 'xsmall',
          alignX: 'center',
          textAlign: 'center',
          padding: '0px 24px',
        }}
      >
        <Text type="title">
          {intl.formatMessage(messages.somethingWentWrong)}
        </Text>
        {error instanceof UserFacingError ? (
          <Text type="body">{error.message}</Text>
        ) : null}
      </view.div>
    </ScreenWrapper>
  );
};

export default AppError;
